module.exports = __webpack_public_path__ + "img/SMFL Leasing.c8adda72.png";